import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      // Navigation
      'nav.home': 'Home',
      'nav.contact': 'Contact Us',
      
      // Header
      'header.title': 'Innovative IT Solutions for Your Business',
      'header.subtitle': 'Transform Your Digital Presence with Cutting-Edge Technology',
      'header.contact': 'Contact Us',

      // Services
      'services.book': 'Book a Call',
      'services.software.title': 'Software Development',
      'services.software.description': 'End-to-end development of custom web and mobile applications, from concept to deployment. We specialize in creating scalable solutions including CRM, ERP systems, and seamless API integrations.',
      
      'services.web.title': 'Web Development & eCommerce',
      'services.web.description': 'Create stunning websites and powerful online stores using cutting-edge technologies. We deliver conversion-optimized solutions with beautiful UX/UI design across various platforms.',
      
      'services.security.title': 'Cybersecurity & Data Protection',
      'services.security.description': 'Comprehensive security solutions to protect your digital assets and ensure GDPR compliance. We implement robust security measures including DDoS protection and advanced authentication systems.',
      
      'services.consulting.title': 'IT Consulting & Outsourcing',
      'services.consulting.description': 'Strategic IT consulting and dedicated development teams to drive your digital transformation. We optimize your IT infrastructure and automate business processes for maximum efficiency.',
      
      'services.cloud.title': 'Cloud Computing & Server Solutions',
      'services.cloud.description': 'Expert implementation of cloud solutions across major platforms with containerized deployment options. We ensure robust server management and scalable infrastructure.',
      
      'services.ai.title': 'Big Data & Artificial Intelligence',
      'services.ai.description': 'Harness the power of AI and machine learning for your business growth. We develop intelligent solutions from data analytics to AI-powered customer service systems.',

      // Stats
      'stats.projects.number': '500+',
      'stats.projects.label': 'Projects Completed',
      'stats.satisfaction.number': '98%',
      'stats.satisfaction.label': 'Client Satisfaction',
      'stats.experience.number': '15+',
      'stats.experience.label': 'Years Experience',

      // Contact Form
      'contact.title': 'Contact Us',
      'contact.name': 'Your Name',
      'contact.email': 'Your Email',
      'contact.subject': 'Subject',
      'contact.message': 'Your Message',
      'contact.send': 'Send Message',
      'contact.address': 'Address',
      'contact.phone': 'Phone',
      'contact.email.label': 'Email',

      // Footer
      'footer.social.connect': 'Get connected with us on social networks:',
      'footer.company.title': 'Executiva',
      'footer.company.description': 'Delivering innovative IT solutions and digital transformation services to businesses worldwide. Your trusted partner in technology.',
      'footer.services.title': 'Services',
      'footer.services.software': 'Software Development',
      'footer.services.web': 'Web Development',
      'footer.services.security': 'Cybersecurity',
      'footer.services.cloud': 'Cloud Solutions',
      'footer.links.title': 'Quick Links',
      'footer.links.about': 'About Us',
      'footer.links.services': 'Services',
      'footer.links.contact': 'Contact',
      'footer.links.privacy': 'Privacy Policy',
      'footer.contact.title': 'Contact',
      'footer.contact.address': '18 Doiranis Street, Egkomi, 2400 Nicosia, Cyprus',
      'footer.contact.email': 'letterexecone@gmail.com',
      'footer.copyright': '© 2024 Copyright:',
      'footer.contact.phone': '+357 99 777234',
      'footer.company.link': 'letterexecutiva.com'
    }
  },
  el: {
    translation: {
      // Navigation
      'nav.home': 'Αρχική',
      'nav.contact': 'Επικοινωνία',
      
      // Header
      'header.title': 'Καινοτόμες Λύσεις Πληροφορικής για την Επιχείρησή σας',
      'header.subtitle': 'Μεταμορφώστε την Ψηφιακή σας Παρουσία με Τεχνολογία Αιχμής',
      'header.contact': 'Επικοινωνία',

      // Services
      'services.book': 'Κλήση',
      'services.software.title': 'Ανάπτυξη Λογισμικού',
      'services.software.description': 'Ολοκληρωμένη ανάπτυξη εφαρμογών web και mobile, από τη σύλληψη έως την υλοποίηση. Ειδικευόμαστε στη δημιουργία κλιμακώσιμων λύσεων συμπεριλαμβανομένων συστημάτων CRM, ERP και ενσωματώσεων API.',
      
      'services.web.title': 'Ανάπτυξη Ιστοσελίδων & E-commerce',
      'services.web.description': 'Δημιουργούμε εντυπωσιακές ιστοσελίδες και ισχυρά ηλεκτρονικά καταστήματα χρησιμοποιώντας τεχνολογίες αιχμής. Παρέχουμε λύσεις βελτιστοποιημένες για μετατροπές με όμορφο σχεδιασμό UX/UI.',
      
      'services.security.title': 'Κυβερνοασφάλεια & Προστασία Δεδομένων',
      'services.security.description': 'Ολοκληρωμένες λύσεις ασφαλείας για την προστασία των ψηφιακών σας περιουσιακών στοιχείων και τη συμμόρφωση με το GDPR. Εφαρμόζουμε ισχυρά μέτρα ασφαλείας.',
      
      'services.consulting.title': 'Συμβουλευτική IT & Outsourcing',
      'services.consulting.description': 'Στρατηγική συμβουλευτική IT και εξειδικευμένες ομάδες ανάπτυξης για τον ψηφιακό μετασχηματισμό σας. Βελτιστοποιούμε την υποδομή IT και αυτοματοποιούμε τις επιχειρηματικές διαδικασίες.',
      
      'services.cloud.title': 'Cloud Computing & Λύσεις Server',
      'services.cloud.description': 'Εξειδικευμένη υλοποίηση cloud λύσεων σε όλες τις μεγάλες πλατφόρμες. Διασφαλίζουμε τη σταθερή διαχείριση και την κλιμακώσιμη υποδομή.',
      
      'services.ai.title': 'Big Data & Τεχνητή Νοημοσύνη',
      'services.ai.description': 'Αξιοποιήστε τη δύναμη της AI και του machine learning για την ανάπτυξη της επιχείρησής σας. Αναπτύσσουμε έξυπνες λύσεις από την ανάλυση δεδομένων έως την εξυπηρέτηση πελατών με AI.',

      // Stats
      'stats.projects.number': '500+',
      'stats.projects.label': 'Ολοκληρωμένα Έργα',
      'stats.satisfaction.number': '98%',
      'stats.satisfaction.label': 'Ικανοποίηση Πελατών',
      'stats.experience.number': '15+',
      'stats.experience.label': 'Χρόνια Εμπειρίας',

      // Contact Form
      'contact.title': 'Επικοινωνία',
      'contact.name': 'Το Όνομά σας',
      'contact.email': 'Το Email σας',
      'contact.subject': 'Θέμα',
      'contact.message': 'Το Μήνυμά σας',
      'contact.send': 'Αποστολή',
      'contact.address': 'Διεύθυνση',
      'contact.phone': 'Τηλέφωνο',
      'contact.email.label': 'Email',

      // Footer
      'footer.social.connect': 'Συνδεθείτε μαζί μας στα social media:',
      'footer.company.title': 'Executiva',
      'footer.company.description': 'Παρέχουμε καινοτόμες λύσεις πληροφορικής και υπηρεσίες ψηφιακού μετασχηματισμού σε επιχειρήσεις παγκοσμίως. Ο αξιόπιστος συνεργάτης σας στην τεχνολογία.',
      'footer.services.title': 'Υπηρεσίες',
      'footer.services.software': 'Ανάπτυξη Λογισμικού',
      'footer.services.web': 'Ανάπτυξη Ιστοσελίδων',
      'footer.services.security': 'Κυβερνοασφάλεια',
      'footer.services.cloud': 'Λύσεις Cloud',
      'footer.links.title': 'Γρήγοροι Σύνδεσμοι',
      'footer.links.about': 'Σχετικά με εμάς',
      'footer.links.services': 'Υπηρεσίες',
      'footer.links.contact': 'Επικοινωνία',
      'footer.links.privacy': 'Πολιτική Απορρήτου',
      'footer.contact.title': 'Επικοινωνία',
      'footer.contact.address': 'Αθήνα, Ελλάδα',
      'footer.contact.email': 'info@executiva.gr',
      'footer.contact.phone': '+357 99 777234',
      'footer.copyright': '© 2024 Copyright:',
      'footer.company.link': 'letterexecutiva.com'
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n; 